import { UseMutationOptions } from 'react-query/types/react/types';
import { AxiosResponse } from 'axios';
import { ErrorResponse } from '../../../../common/types/errorRespose';
import { useMutation, UseMutationResult } from 'react-query';
import { SamlIdentityProvidersApi } from '../../../../api-client';
import { getApiConfiguration } from '../../../../common';

type UseDisableSamlProvider = (
  options?: Omit<UseMutationOptions<AxiosResponse<void>,
    ErrorResponse,
    { id: string }>,
    'mutationFn'>,
) => UseMutationResult<AxiosResponse<void>,
  ErrorResponse,
  { id: string }>;

export const useDisableSamlProvider: UseDisableSamlProvider = (
  options,
) => {
  const tenantId = localStorage.getItem('tenantId') as string;
  const samlIdentityProviderApi = new SamlIdentityProvidersApi(getApiConfiguration());
  return useMutation(
    ({ id }: { id: string }) =>
      samlIdentityProviderApi.disableSamlProvider(id, tenantId),
    options,
  );
}
